/* -------------------------------------------------------------------------- */
/*                                 step wizard                                */
/* -------------------------------------------------------------------------- */
import utils from './utils';

const wizardInit = () => {
  const { getData } = utils;

  const selectors = {
    WIZARDS: '.theme-wizard',
    TOGGLE_BUTTON_EL: '[data-wizard-step]',
    FORMS: '[data-wizard-form]',
    PASSWORD_INPUT: '[data-wizard-password]',
    CONFIRM_PASSWORD_INPUT: '[data-wizard-confirm-password]',
    NEXT_BTN: '.next button',
    PREV_BTN: '.previous button',
    FOOTER: '.theme-wizard .card-footer'
  };

  const callbacks = {
    beforeNext: null,
    waitResponse: null
  };

  const events = {
    SUBMIT: 'submit',
    SHOW: 'show.bs.tab',
    SHOWN: 'shown.bs.tab',
    CLICK: 'click'
  };

  const wizards = document.querySelectorAll(selectors.WIZARDS);

  wizards.forEach(wizard => {

    // Get custom callback handler name from data attribute
    const beforeNextHandlerName = wizard.getAttribute('data-on-before-next');
    const waitResponseHandlerName = wizard.getAttribute('data-on-wait-response');

    // If handler name is specified and exists in window scope, use it
    if (beforeNextHandlerName && window[beforeNextHandlerName]) {
      callbacks.beforeNext = window[beforeNextHandlerName];
    }

    // If handler name is specified and exists in window scope, use it
    if (waitResponseHandlerName && window[waitResponseHandlerName]) {
      callbacks.waitResponse = window[waitResponseHandlerName];
    }


    const tabToggleButtonEl = wizard.querySelectorAll(selectors.TOGGLE_BUTTON_EL);
    const forms = wizard.querySelectorAll(selectors.FORMS);
    const passwordInput = wizard.querySelector(selectors.PASSWORD_INPUT);
    const confirmPasswordInput = wizard.querySelector(selectors.CONFIRM_PASSWORD_INPUT);
    const nextButton = wizard.querySelector(selectors.NEXT_BTN);
    const prevButton = wizard.querySelector(selectors.PREV_BTN);
    const wizardFooter = wizard.querySelector(selectors.FOOTER);
    const submitEvent = new Event(events.SUBMIT, {
      bubbles: true,
      cancelable: true
    });

    const tabs = Array.from(tabToggleButtonEl).map(item =>
      window.bootstrap.Tab.getOrCreateInstance(item)
    );

    let count = 0;
    let showEvent = null;

    forms.forEach(form => {
      form.addEventListener(events.SUBMIT, async e => {
        e.preventDefault();
        if (form.classList.contains('needs-validation')) {
          if (passwordInput && confirmPasswordInput) {
            if (passwordInput.value !== confirmPasswordInput.value) {
              confirmPasswordInput.setCustomValidity('Invalid field.');
            } else {
              confirmPasswordInput.setCustomValidity('');
            }
          }

          if (!form.checkValidity()) {
            if (showEvent) showEvent.preventDefault();
            return false;
          }

          // Handle case with callbacks
          if (callbacks.beforeNext) {
            e.preventDefault();

            try {
              const shouldProceed = await callbacks.beforeNext(count, forms[count]);
              if (!shouldProceed) return false;
            } catch (error) {
              console.error('Validation error:', error);
              return false;
            }
          }

          // Handle case with callbacks - return true,
          // if response from server positive on creating new user, ...
          if (callbacks.waitResponse) {
            e.preventDefault();

            try {
              const shouldProceed = await callbacks.waitResponse(count, forms[count]);
              if (!shouldProceed) return false;
            } catch (error) {
              console.error('Validation error:', error);
              return false;
            }
          }
        }

        // here all good, ...
        // Proceed to next tab if allowed
        if (count + 1 < tabs.length) tabs[count + 1].show();
        count += 1;
        return null;
      });
    });

    nextButton.addEventListener(events.CLICK, () => {

      forms[count].dispatchEvent(submitEvent);

      // Proceed to next tab if allowed
      //if (count + 1 < tabs.length) tabs[count + 1].show();
    });

    prevButton.addEventListener(events.CLICK, () => {
      count -= 1;
      tabs[count].show();
    });

    if (tabToggleButtonEl.length) {
      tabToggleButtonEl.forEach((item, index) => {
        item.addEventListener(events.SHOW, e => {
          const step = getData(item, 'wizard-step');
          showEvent = e;
          if (step > count) {
            forms[count].dispatchEvent(submitEvent);
          }
        });
        item.addEventListener(events.SHOWN, () => {
          count = index;
          // can't go back tab
          if (count === tabToggleButtonEl.length - 1) {
            tabToggleButtonEl.forEach(tab => {
              tab.setAttribute('data-bs-toggle', 'modal');
              tab.setAttribute('data-bs-target', '#error-modal');
            });
          }
          // add done class
          for (let i = 0; i < count; i += 1) {
            tabToggleButtonEl[i].classList.add('done');
            if (i > 0) {
              tabToggleButtonEl[i - 1].classList.add('complete');
            }
          }
          // remove done class
          for (let j = count; j < tabToggleButtonEl.length; j += 1) {
            tabToggleButtonEl[j].classList.remove('done');
            if (j > 0) {
              tabToggleButtonEl[j - 1].classList.remove('complete');
            }
          }

          // card footer remove at last step
          if (count > tabToggleButtonEl.length - 2) {
            wizardFooter.classList.add('d-none');
          } else {
            wizardFooter.classList.remove('d-none');
          }
          // prev-button removing
          if (count > 0 && count !== tabToggleButtonEl.length - 1) {
            prevButton.classList.remove('d-none');
          } else {
            prevButton.classList.add('d-none');
          }
        });
      });
    }
  });

  /*
   Return the callback setter
  */
  return {
    onBeforeNext: (callback) => { callbacks.beforeNext = callback; },
    onWaitResponse: (callback) => { callbacks.waitResponse = callback; }
  };
};

export default wizardInit;
